import { RouteRecordRaw } from "vue-router";

export const publicReportRoute: RouteRecordRaw[] = [
  {
    path: "report/:id",
    name: "report",
    meta: {
      activityArea: null,
      // The reader also opens a member's own reports; only a share link
      // carries the token.
      publicShare: "with-token",
      title: "Report",
      requiresAuth: false,
      shell: "reader",
      navbar: "authenticated",
      sidepanel: "hidden",
      contentWidth: "full-bleed",
      breadcrumb: false,
    },
    component: () => import("@/views/Reporting/ReportPublic.vue"),
  },
];
export const dashboardRoute: RouteRecordRaw = {
  path: "/dashboard",
  name: "dashboard",
  redirect: { name: "dashboard-overview" },
  meta: {
    activityArea: "dashboards",
    title: "Custom dashboards",
    text: "Dashboards",
    description: "Dynamically updated dashboards showing your current stats.",
    icon: "chart-line-light",
    helpDeskPath: "reporting",
    requiresAuth: true,
    shell: "application",
    navbar: "persistent",
    sidepanel: "global",
    contentWidth: "full-bleed",
    breadcrumb: {
      label: "Dashboards",
      to: { name: "dashboard-overview" },
    },
    isDirect: true,
  },
  children: [
    {
      path: "overview",
      name: "dashboard-overview",
      meta: {
        title: "Custom Dashboards",
        contentWidth: "wide",
        breadcrumb: false,
      },
      component: () => import("@/views/Dashboard/DashboardManagement.vue"),
    },
    {
      path: "edit/:pk",
      name: "edit-dashboard",
      meta: {
        title: "Edit Dashboard",
        // Its sync and save state are one dashboard's: kept across
        // dashboards, the next autosave writes A's layout into B.
        remountOnParam: "pk",
        contentWidth: "full-bleed",
        breadcrumb: {
          label: "Dashboard",
          dynamic: true,
          fallback: "Dashboard editor",
        },
      },
      component: () => import("@/views/Dashboard/CustomizeDashboard.vue"),
    },
    {
      path: ":pk",
      name: "view-dashboard",
      meta: {
        title: "View Dashboard",
        contentWidth: "full-bleed",
        breadcrumb: {
          label: "Dashboard",
          dynamic: true,
          fallback: "Dashboard",
        },
      },
      component: () => import("@/views/Dashboard/Dashboard.vue"),
    },
  ],
};

export const dashboardLegacyRoutes: RouteRecordRaw[] = [
  {
    path: "/dashboards",
    name: "dashboards",
    redirect: { name: "dashboard-overview" },
    meta: {
      title: "Custom dashboards",
      requiresAuth: true,
      breadcrumb: false,
    },
  },
];

export const reportingRoutes: RouteRecordRaw[] = [
  dashboardRoute,
  ...dashboardLegacyRoutes,
  // FIXME: should be removed in the future instead of commented out
  // {
  //   path: "reports",
  //   redirect: { name: "reporting-overview" },
  //   name: "reports-reports-base",
  //   meta: {
  //     title: "Reporting",
  //     added: "2023-01-06",
  //     text: "Reports",
  //     description: "Read reports for specific date ranges.",
  //     icon: "file-alt",
  //     helpDeskPath: "reporting",
  //   },
  //   component: () => import("@/views/Reporting/ReportingBase.vue"),
  //   children: [
  //     {
  //       path: "overview",
  //       name: "reporting-overview",
  //       meta: { title: "Reports" },
  //       component: () => import("@/views/Reporting/Overview.vue"),
  //     },
  //   ],
  // },
];
